export default __webpack_public_path__ + "static/media/svg-6.2c373ff8.svg";